export const CHAR_LIMIT = 150;
export const REFERRAL_PARENT_VALUE = 'referral';
export const REFERRAL_CHILD_PREFIX = 'Referral, ';

export enum FormField {
  // Header
  PROVIDER_NURSE = 'providerNurse',

  // Prior Health Status
  CARE_STATUS_BEFORE_ADMISSION = 'careStatusBeforeAdmission',
  LIVING_ARRANGEMENT_PRIOR_TO_ADMISSION = 'livingArrangementPriorToAdmission',
  NEEDS_BEFORE_DISCHARGE = 'needsBeforeDischarge',
  OTHER_NEEDS = 'otherNeeds',

  // Discharge Summary & Instructions
  SERVICES_ESTABLISHED_AFTER_DISCHARGE = 'servicesEstablishedAfterDischarge',
  SERVICES_ESTABLISHED_OTHER = 'servicesEstablishedAfterDischargeOther',
  LIVING_ARRANGEMENT_ON_DISCHARGE = 'livingArrangementOnDischarge',
  LIVING_ARRANGEMENT_ON_DISCHARGE_OTHER = 'livingArrangementOnDischargeOther',
  PHYSICAL_CHALLENGES_AT_HOME = 'physicalChallengesAtHome',
  PHYSICAL_CHALLENGES_AT_HOME_OTHER = 'physicalChallengesAtHomeOther',
  TRANSPORTATION_HOME_FROM_HOSPITAL = 'transportationHomeFromHospital',
  TRANSPORTATION_HOME_FROM_HOSPITAL_OTHER = 'transportationHomeFromHospitalOther',

  // Caregiver Information
  CAREGIVER_AT_HOME = 'caregiverAtHome',
  CAREGIVER_AT_HOME_OTHER = 'caregiverAtHomeOther',
  GIVE_DISCHARGE_INSTRUCTIONS_TO = 'giveDischargeInstructionsTo',
  GIVE_DISCHARGE_INSTRUCTIONS_TO_OTHER = 'giveDischargeInstructionsToOther',
  CAREGIVER_NAME = 'caregiverName',
  DISCHARGE_INSTRUCTIONS_NAME = 'dischargeInstructionsName',
  FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL = 'familyCaregiverMotivationalLevel',
  FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL_OTHER = 'familyCaregiverMotivationalLevelOther',
  OTHER_MOTIVATIONAL_OBSERVATIONS = 'otherMotivationalObservations'
}

export const OTHER_FIELD_DEPENDENCIES = [
  { parent: FormField.SERVICES_ESTABLISHED_AFTER_DISCHARGE, other: FormField.SERVICES_ESTABLISHED_OTHER },
  { parent: FormField.LIVING_ARRANGEMENT_ON_DISCHARGE, other: FormField.LIVING_ARRANGEMENT_ON_DISCHARGE_OTHER },
  { parent: FormField.PHYSICAL_CHALLENGES_AT_HOME, other: FormField.PHYSICAL_CHALLENGES_AT_HOME_OTHER },
  { parent: FormField.TRANSPORTATION_HOME_FROM_HOSPITAL, other: FormField.TRANSPORTATION_HOME_FROM_HOSPITAL_OTHER },
  { parent: FormField.CAREGIVER_AT_HOME, other: FormField.CAREGIVER_AT_HOME_OTHER },
  { parent: FormField.GIVE_DISCHARGE_INSTRUCTIONS_TO, other: FormField.GIVE_DISCHARGE_INSTRUCTIONS_TO_OTHER },
  { parent: FormField.FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL, other: FormField.FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL_OTHER }
];

export const SELF_NAME_FIELD_DEPENDENCIES = [
  { parent: FormField.CAREGIVER_AT_HOME, name: FormField.CAREGIVER_NAME },
  { parent: FormField.GIVE_DISCHARGE_INSTRUCTIONS_TO, name: FormField.DISCHARGE_INSTRUCTIONS_NAME }
];

export const MULTISELECT_NONE_EXCLUSIVE_FIELDS = new Set<FormField>([
  FormField.NEEDS_BEFORE_DISCHARGE,
  FormField.SERVICES_ESTABLISHED_AFTER_DISCHARGE,
  FormField.PHYSICAL_CHALLENGES_AT_HOME,
  FormField.FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL
]);

export enum SectionTitle {
  DISCHARGE_PLANNING = 'Discharge Planning',
  PRIOR_HEALTH_STATUS = 'Prior Health Status',
  DISCHARGE_SUMMARY_AND_INSTRUCTIONS = 'Discharge Summary & Instructions',
  CAREGIVER_INFORMATION = 'Caregiver Information'
}

export enum FormFieldLabel {
  // Header
  PROVIDER_NURSE = 'Provider / Nurse',

  // Prior Health Status
  CARE_STATUS_BEFORE_ADMISSION = 'Care Status Before Admission',
  LIVING_ARRANGEMENT_PRIOR_TO_ADMISSION = 'Living Arrangement Prior to Admission',
  NEEDS_BEFORE_DISCHARGE = 'Needs Before Discharge',
  OTHER_NEEDS = 'Other Needs:',

  // Discharge Summary & Instructions
  SERVICES_ESTABLISHED_AFTER_DISCHARGE = 'Services Established After Discharge',
  SERVICES_ESTABLISHED_OTHER = 'Other:',
  LIVING_ARRANGEMENT_ON_DISCHARGE = 'Living Arrangement on Discharge',
  LIVING_ARRANGEMENT_ON_DISCHARGE_OTHER = 'Other:',
  PHYSICAL_CHALLENGES_AT_HOME = 'Physical Challenges at Home',
  PHYSICAL_CHALLENGES_AT_HOME_OTHER = 'Other:',
  TRANSPORTATION_HOME_FROM_HOSPITAL = 'Transportation Home from the Hospital',
  TRANSPORTATION_HOME_FROM_HOSPITAL_OTHER = 'Other:',

  // Caregiver Information
  CAREGIVER_AT_HOME = 'Caregiver at Home',
  CAREGIVER_AT_HOME_OTHER = 'Other:',
  GIVE_DISCHARGE_INSTRUCTIONS_TO = 'Give Discharge Instructions to:',
  GIVE_DISCHARGE_INSTRUCTIONS_TO_OTHER = 'Other:',
  CAREGIVER_NAME = 'Name',
  DISCHARGE_INSTRUCTIONS_NAME = 'Name',
  FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL = 'Family/Caregiver Motivational Level',
  FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL_OTHER = 'Other:',
  OTHER_MOTIVATIONAL_OBSERVATIONS = 'Other Motivational Observations'
}

export enum SavedFormFieldLabel {
  CAREGIVER_AT_HOME_NAME = 'Caregiver at Home - Name',
  GIVE_DISCHARGE_INSTRUCTIONS_TO_NAME = 'Give Discharge Instructions to - Name',
  SERVICES_ESTABLISHED_OTHER = 'Other Services Established After Discharge:',
  LIVING_ARRANGEMENT_ON_DISCHARGE_OTHER = 'Other Living Arrangement on Discharge:',
  PHYSICAL_CHALLENGES_AT_HOME_OTHER = 'Other Physical Challenges at Home:',
  TRANSPORTATION_HOME_FROM_HOSPITAL_OTHER = 'Other Transportation Home from the Hospital:',
  CAREGIVER_AT_HOME_OTHER = 'Other Caregiver at Home:',
  GIVE_DISCHARGE_INSTRUCTIONS_TO_OTHER = 'Other Give Discharge Instructions to:',
  FAMILY_CAREGIVER_MOTIVATIONAL_LEVEL_OTHER = 'Other Family/Caregiver Motivational Level:'
}
